import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { StudentDetailsModal } from 'shared/components';
import './StudentsList.scss';
import ArrowDown from 'assets/svgs/arrowDown.svg';
import StudentIcon from 'assets/svgs/user.svg';
import NoStudentIcon from 'assets/svgs/noUsers.svg';
import DeassignStudentIcon from 'assets/svgs/removeUser.svg';
import OnlineIcon from 'assets/svgs/onlineIconBlack.svg';
import AccomodationIcon from 'assets/svgs/accomodationIconBlack.svg';
import StandByIcon from 'assets/svgs/standbyIconBlack.svg';
import LeftHandedIcon from 'assets/svgs/leftHandedIconBlack.svg';

const LIST_PADDING = 182;
const SCROLL_Y = 100;

class StudentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      selectedExaminee: {},
    };
    this.scroll = this.scroll.bind(this);
    this.setContentHeight = this.setContentHeight.bind(this);
    this.displayScrollArrows = this.displayScrollArrows.bind(this);
    this.showExamineeDetails = this.showExamineeDetails.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.setContentHeight);
  }

  componentDidUpdate() {
    this.setContentHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setContentHeight);
  }

  setContentHeight() {
    const listElement = document.getElementById('students-list');
    const gridElement = document.getElementById('seating-chart-grid');
    const height =
      window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    let computedHeight = height - LIST_PADDING - gridElement.getBoundingClientRect().top;
    computedHeight = computedHeight < 350 ? 350 : computedHeight;

    listElement.style.maxHeight = listElement && computedHeight + 'px';
    gridElement.style.maxHeight = gridElement && computedHeight + 'px';
    listElement.style.height = listElement && computedHeight + 'px';

    if (!isEmpty(this.props.studentsList)) {
      this.displayScrollArrows();
    }
  }

  scroll(direction) {
    const element = document.getElementById('students-list');
    const scroll_y = direction === 'top' ? -SCROLL_Y : SCROLL_Y;

    if (window.scrollBy) {
      element.scrollBy({
        behavior: 'smooth',
        top: direction === 'top' ? -SCROLL_Y : SCROLL_Y,
      });
    } else {
      element.scrollTop += scroll_y;
    }

    this.displayScrollArrows();
  }

  displayScrollArrows() {
    const element = document.getElementById('students-list');
    // console.log(element.scrollTop, element.scrollHeight, element.clientHeight + element.scrollTop)
    //element.scrollHeight - element.scrollTop === element.clientHeight
    if (!element.scrollTop) {
      document.getElementById('students-list-scroll-top').classList.add('disabled');
    } else {
      document.getElementById('students-list-scroll-top').classList.remove('disabled');
    }

    if (element.scrollHeight <= element.clientHeight + element.scrollTop) {
      document.getElementById('students-list-scroll-bottom').classList.add('disabled');
    } else {
      document.getElementById('students-list-scroll-bottom').classList.remove('disabled');
    }
  }

  showExamineeDetails(examinee) {
    this.setState({
      modalIsOpen: true,
      selectedExaminee: examinee,
    });
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
    });
  }

  render() {
    const { studentsList, handleSeatSelect, selectedStudent, hasNowManagedFlag } = this.props;

    return (
      <div className="students-list" id="students-list">
        {
          <React.Fragment>
            {!isEmpty(studentsList) && (
              <div className={`btn-scroll-y`} id="students-list-scroll-top">
                <ArrowDown onClick={() => this.scroll('top')} />
              </div>
            )}
            <div className="students-list-scroll">
              <Droppable droppableId="droppable-students">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    className={`deassign-container ${
                      snapshot.isDraggingOver && !snapshot.draggingFromThisWith
                        ? 'dragging-over'
                        : ''
                    }`}>
                    {!isEmpty(studentsList) ? (
                      studentsList.map((student) => (
                        <Draggable
                          key={student.id}
                          draggableId={`student-${student.id}`}
                          index={student.id}>
                          {(provided, snapshot) => (
                            <div
                              className={`student ${
                                !isEmpty(selectedStudent) && student.id === selectedStudent.index
                                  ? 'selected'
                                  : ''
                              } ${snapshot.isDragging ? 'is-dragging' : ''}`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              onClick={() => handleSeatSelect(student.id)}
                              onDoubleClick={() => this.showExamineeDetails(student)}>
                              <StudentIcon />
                              <div className="student-info">
                                <div>{student.lastName}, </div>
                                <div>{student.firstName}</div>
                              </div>
                              {(student.standbyFlag ||
                                student.leftHandedFlag ||
                                student.accomRosterFlag ||
                                student.onlineFlag) && (
                                <div className="student-flags">
                                  {student.standbyFlag && (
                                    <span
                                      tabIndex="0"
                                      className="icons d-inline-block"
                                      data-bs-toggle="popover"
                                      data-bs-placement="top"
                                      data-bs-trigger="focus"
                                      data-bs-content={this.props.t('rosters.tooltipStandBy')}>
                                      <StandByIcon />
                                    </span>
                                  )}
                                  {student.leftHandedFlag && (
                                    <span
                                      tabIndex="0"
                                      className="icons d-inline-block"
                                      data-bs-toggle="popover"
                                      data-bs-placement="top"
                                      data-bs-trigger="focus"
                                      data-bs-content={this.props.t('rosters.tooltipLeftHand')}>
                                      <LeftHandedIcon />
                                    </span>
                                  )}
                                  {student.onlineFlag && (
                                    <div
                                      tabIndex="0"
                                      className="icons d-inline-block"
                                      data-bs-toggle="popover"
                                      data-bs-placement="top"
                                      data-bs-trigger="focus"
                                      data-bs-content={this.props.t('rosters.tooltipOnline')}>
                                      <OnlineIcon />
                                    </div>
                                  )}
                                  {student.accomRosterFlag && (
                                    <span
                                      tabIndex="0"
                                      className="icons d-inline-block"
                                      data-bs-toggle="popover"
                                      data-bs-placement="top"
                                      data-bs-trigger="focus"
                                      data-bs-content={this.props.t('rosters.tooltipAccomodation')}>
                                      <AccomodationIcon />
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </Draggable>
                      ))
                    ) : (
                      <div className="no-examinees">
                        <div>
                          <NoStudentIcon />
                        </div>
                        {this.props.t('seatingChart.noExamineesMessage')}
                      </div>
                    )}
                    {provided.placeholder}

                    <div className="drag-deassign">
                      <div>
                        <DeassignStudentIcon />
                      </div>
                      {this.props.t('seatingChart.dragToDeassign')}
                    </div>
                  </div>
                )}
              </Droppable>
            </div>
            {!isEmpty(studentsList) && (
              <div className={`btn-scroll-y`} id="students-list-scroll-bottom">
                <ArrowDown onClick={() => this.scroll('bottom')} />
              </div>
            )}
          </React.Fragment>
        }

        <StudentDetailsModal
          student={this.state.selectedExaminee}
          modalIsOpen={this.state.modalIsOpen}
          closeModal={this.closeModal}
          nowManagedFlag={hasNowManagedFlag}
        />
      </div>
    );
  }
}

export default withTranslation()(StudentsList);
StudentsList.propTypes = {
  studentsList: PropTypes.arrayOf(PropTypes.shape({})),
  handleSeatSelect: PropTypes.func,
  selectedStudent: PropTypes.shape({}),
  hasNowManagedFlag: PropTypes.bool,
  t: PropTypes.func.isRequired,
};
